import { getEnviroment } from 'utils/getEnviroment';

const { isDevelopment } = getEnviroment();
export const API_MODE = isDevelopment ? 'dev' : 'dev';
